// Idempotent loader for the YouTube IFrame Player API. Returns a Promise that
// resolves with the `YT` namespace once the script has finished loading.
//
// Safe to call from many components simultaneously — only one script tag is
// ever injected, and concurrent callers all settle on the same promise.

let loadPromise = null;

export function loadYouTubeApi() {
  if (typeof window === "undefined") return Promise.reject(new Error("SSR"));
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    // The API calls window.onYouTubeIframeAPIReady once ready. If some other
    // caller has already set a handler, chain ours after theirs.
    const previousReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      try { if (typeof previousReady === "function") previousReady(); } catch (e) { /* noop */ }
      if (window.YT && window.YT.Player) resolve(window.YT);
      else reject(new Error("YT API loaded but namespace missing"));
    };

    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    tag.async = true;
    tag.onerror = () => reject(new Error("YT API script failed to load"));
    document.head.appendChild(tag);
  });
  return loadPromise;
}
